export default __webpack_public_path__ + "static/media/test.991514cb.csv";